var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedRemoteAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 136,
    viewBox: "0 0 107 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9882",
    "data-name": "Group 9882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9877",
    "data-name": "Group 9877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M95.87,29.41a3.185,3.185,0,0,1-.51-.04H12.51a5.947,5.947,0,0,1-4.45-2.01C2.44,21.39,3.6,2.91,3.65,2.12l2.6.17c-.33,5.03-.31,19.02,3.71,23.3a3.376,3.376,0,0,0,2.55,1.19H95.66l.17.05h.04a2.077,2.077,0,0,0,1.31-.6c1.7-1.5,4.43-6.6,3.58-23.95l2.6-.13c.7,14.36-.87,23.18-4.68,26.21A4.524,4.524,0,0,1,95.87,29.41Z",
    fill: "#ff69b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M104.19,130.32H2.81A2.81,2.81,0,0,1,0,127.52V2.8A2.81,2.81,0,0,1,2.81,0H104.19A2.81,2.81,0,0,1,107,2.8V127.52A2.81,2.81,0,0,1,104.19,130.32ZM2.81,2.6a.2.2,0,0,0-.2.2V127.52a.2.2,0,0,0,.2.2H104.19a.2.2,0,0,0,.2-.2V2.8a.2.2,0,0,0-.2-.2Z",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9879",
    "data-name": "Group 9879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M16.16,136H12.59a3.683,3.683,0,0,1-3.74-3.61v-3.4h2.61v3.4a1.084,1.084,0,0,0,1.13,1.02h3.57a1.084,1.084,0,0,0,1.13-1.02v-3.4H19.9v3.4A3.683,3.683,0,0,1,16.16,136Z",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9880",
    "data-name": "Group 9880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M96.64,136H93.07a3.683,3.683,0,0,1-3.74-3.61v-3.4h2.61v3.4a1.084,1.084,0,0,0,1.13,1.02h3.57a1.084,1.084,0,0,0,1.13-1.02v-3.4h2.61v3.4A3.689,3.689,0,0,1,96.64,136Z",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9881",
    "data-name": "Group 9881"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4313",
    "data-name": "Rectangle 4313",
    width: 104.39,
    height: 2.6,
    transform: "translate(1.3 109.13)",
    fill: "#58595b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4314",
    "data-name": "Rectangle 4314",
    width: 25.29,
    height: 18.51,
    transform: "translate(40.61 5.65)",
    fill: "#404041",
    stroke: "#6d6e70",
    strokeMiterlimit: 10,
    strokeWidth: 1.443
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedRemoteAccess);
export default __webpack_public_path__ + "static/media/led_remote_access.ae23d04513802b46982e3b451aa5cd2d.svg";
export { ForwardRef as ReactComponent };